import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { GetDataPromise } from "../Functions/SendingData";
import { apiMain } from "../../App";
import { makeClickEvent } from "../Functions/SetHeaders";

const Styles = styled.div`
  width: calc(100% - calc(var(--universal-pad) * 2));
  margin: 2rem var(--universal-pad) 2rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  &.type-3-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width:850px) {
    grid-template-columns: repeat(1, 1fr);
    margin: 0 1rem 1rem;
    width: calc(100% - 2rem);
    &.type-3-grid {
      grid-template-columns: repeat(1, 1fr);
    }
  }
  .link {
    grid-row: 2 span;
    text-decoration: none;
    color: inherit;
    position: relative;
    border-radius: var(--border-radius-3);
    overflow: hidden;
    border: 1px solid var(--n-grey-1);
    box-shadow: 0px 23px 40px -13px #00000014;
    display: flex;
    flex-direction: column;
    aspect-ratio: 0.8;
    &.type-2 {
      grid-row: 1 span;
      aspect-ratio: 1.7;
      .base-image {
        aspect-ratio: 1.7;
      }
    }
    &.type-3 {
      grid-row: 1 span;
      aspect-ratio: 2.15;
      .base-image {
        aspect-ratio: 2.15;
        img {
          aspect-ratio: 2.15;
        }
      }
    }
    &.errored{
      .loading {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background: red;
        opacity: 0.3;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .base-image {
      width: 100%;
      height: 100%;
      aspect-ratio: 0.8;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        overflow: hidden;
        opacity: 0;
        transition: opacity 0.5s ease-in-out;
      }
    }
    .on-top {
      width: 100%;
      position: absolute;
      inset: auto 0 0 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        overflow: hidden;
      }
    }
  }
  
  .loading {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
    position: absolute;
    top: 0;
    left: 0;
  }
  
  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export default function Banner4Main5(props) {
  const {data: dataRaw, lan} = props;
  const dataDefault = JSON.parse(dataRaw);
  const [data, setData] = useState(dataDefault.Images);
  const [loading, setLoading] = useState({});

  useEffect(() => {
    for (let i = 0; i < dataDefault.Images.length; i++) {
      const element = dataDefault.Images[i];
      if(element.camp_id){
        setData((prev) => {
          let temp = { ...prev };
          temp[i].camp_data = {}
          return temp;
        });
        mainFetch({index: i, campID: element.camp_id})
      }
    }
  }, []);
  const mainFetch = async ({index = 0, campID = 1}) => {
    try {
      setLoading((prev) => {
        let temp = { ...prev };
        temp[index] = true;
        return temp;
      });
      const uparams = new URLSearchParams();
      uparams.append("Camp_Id", campID);
      let res = await GetDataPromise(
        `${apiMain}/api/v1/agencies/agencycampaign/active_ad?${uparams.toString()}`
      );
      const parsed = JSON.parse(res);
      if (parsed && parsed.status && parsed.status !== "error") {
        if(parsed.data.length){
          setData((prev) => {
            let temp = { ...prev };
            temp[index].camp_data = parsed.data[0]
            return temp;
          });
        }
        
      }
      setLoading((prev) => {
        let temp = { ...prev };
        temp[index] = false;
        return temp;
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  const clickEvent = async (camp = {}) => {
    if(Object.keys(camp).length){
      makeClickEvent(camp.Agancy_Camp_Id)
    }
  }
  const makeCart1 = (index = 0, className = "link") => {
    if (loading[index]) {
      return <SkeletonLoader className={className}/>;
    }
    let itemMain = data[index];
    let campData = {};
    try {
      const parsedFirstLayer = JSON.parse(itemMain.camp_data.Agancy_Camp_Data);
      campData = parsedFirstLayer;
    } catch (e) {
      campData = {
        link: itemMain.link,
        Image: itemMain.ImageMobile,
      }
    }



    let link = (campData.link) ? campData.link : "";
    if(link.search("http") !== -1){
      return (
        <a className={className} href={link} target="_blank" rel="noreferrer" onClick={() => clickEvent(itemMain.camp_data)}>
          <div className="base-image">
            <img
              src={campData.Image || ""}
              alt="banner"
              onLoad={(e) => (e.target.style.opacity = "1")}
            />
          </div>
        </a>
      )
    }
    return (
      <Link className={className} to={link} onClick={(e) => clickEvent(itemMain.camp_data)}>
        <div className="base-image">
          <img
            src={campData.Image || ""}
            alt="banner"
            onLoad={(e) => (e.target.style.opacity = "1")}
          />
        </div>
      </Link>
    );
  };
  if(dataDefault.model === "2"){
    return (
      <Styles className='type-3-grid'>
        {makeCart1(0, "link type-3")}
        {makeCart1(1, "link type-3")}
      </Styles>
    )
  }
  return (
    <Styles>
      {makeCart1(0, "link")}
      {makeCart1(1, "link type-2")}
      {makeCart1(3, "link ")}
      {makeCart1(2, "link type-2")}
    </Styles>
  );
}

const SkeletonLoader = ({className}) => {
  if(className === "errored"){
    return (
      <div className={className}>
        <div
          className="base-image"
        />
      </div>
    );
  }
  return (
    <div className={className}>
      <div
        className="base-image loading"
      />
    </div>
  );
};



// import React  from 'react';
// import { Link } from 'react-router-dom';
// import styled from 'styled-components';
// const Styles = styled.div`
//   width: calc(100% - calc(var(--universal-pad) * 2));
//   margin: 2rem var(--universal-pad) 2rem;
//   display: grid;
//   grid-template-columns: repeat(3, 1fr);
//   gap: 1rem;
//   &.type-3-grid {
//     grid-template-columns: repeat(2, 1fr);
//   }
//   @media screen and (max-width:850px) {
//     grid-template-columns: repeat(1, 1fr);
//     margin: 0 1rem 1rem;
//     width: calc(100% - 2rem);
//     &.type-3-grid {
//       grid-template-columns: repeat(1, 1fr);
//     }
//   }
//   .link {
//     grid-row: 2 span;
//     text-decoration: none;
//     color: inherit;
//     position: relative;
//     border-radius: var(--border-radius-3);
//     overflow: hidden;
//     border: 1px solid var(--n-grey-1);
//     box-shadow: 0px 23px 40px -13px #00000014;
//     display: flex;
//     flex-direction: column;
//     &.type-2 {
//       grid-row: 1 span;
//       .base-image {
//         aspect-ratio: 1.7;
//       }
//     }
//     &.type-3 {
//       grid-row: 1 span;
//       .base-image {
//         aspect-ratio: 2.15;
//         img {
//           aspect-ratio: 2.15;
//         }
//       }
//     }
//     .base-image {
//       width: 100%;
//       height: 100%;
//       aspect-ratio: 0.8;
//       img {
//         width: 100%;
//         height: 100%;
//         object-fit: cover;
//         display: block;
//         overflow: hidden;
//       }
//     }
//     .on-top {
//       width: 100%;
//       position: absolute;
//       inset: auto 0 0 0;
//       img {
//         width: 100%;
//         height: 100%;
//         object-fit: cover;
//         display: block;
//         overflow: hidden;
//       }
//     }
//   }
// `
// export default function Banner4Main5 (props){
//   const {data: dataRaw, lan} = props;
//   const data = JSON.parse(dataRaw);
//   const makeCart1 = (item, className = "link") => {
//     if(!item.link) {
//       return(
//         <div className={className}>
//           <div className='base-image'>
//             <img src={item.ImageMobile} alt='banner'/>
//           </div>
//           {
//             (item.ImageTop) ? (
//               <div className='on-top'>
//                 <img src={item.ImageTop} alt='banner'/>
//               </div>
//             ) : ""
//           }
//         </div>
//       )
//     }
//     if(item.link.search("http") !== -1){
//       return (
//         <a className={className} href={item.link} rel="noopener nofollow" target='_blank'>
//           <div className='base-image'>
//             <img src={item.ImageMobile} alt='banner'/>
//           </div>
//           {
//             (item.ImageTop) ? (
//               <div className='on-top'>
//                 <img src={item.ImageTop} alt='banner'/>
//               </div>
//             ) : ""
//           }
//         </a>
//       )
//     }
//     return (
//       <Link className={className} to={"/" + lan.filename + item.link}>
//         <div className='base-image'>
//           <img src={item.ImageMobile} alt='banner'/>
//         </div>
//         {
//           (item.ImageTop) ? (
//             <div className='on-top'>
//               <img src={item.ImageTop} alt='banner'/>
//             </div>
//           ) : ""
//         }
//       </Link>
//     )
//   }
//   if(data.model === "2"){
//     return (
//       <Styles className='type-3-grid'>
//         {makeCart1(data.Images[0], "link type-3")}
//         {makeCart1(data.Images[1], "link type-3")}
//       </Styles>
//     )
//   }
//   return (
//     <Styles>
//       {makeCart1(data.Images[0])}
//       {makeCart1(data.Images[1], "link type-2")}
//       {makeCart1(data.Images[3])}
//       {makeCart1(data.Images[2], "link type-2")}
//     </Styles>
//   )
// }